module.exports = __webpack_public_path__ + "static/media/IMG_9582.7bb5d4ef.jpg";